(function ($) {

  $('body').on('mouseover', '.language_switcher', function(){
    $(this).find('.langs-container').stop().fadeIn(450)
  });

  $('body').on('mouseleave', '.language_switcher', function(){
    $(this).find('.langs-container').stop().fadeOut(450)
  });

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/header.js